<template>
  <div class="contacts-upload-google p-5">
    <b-card-group>

      <b-card :title="$t('onboarding.sync-connections.sync-google.step1-title')" img-top img-src="/static/images/illustrations/12.svg" class="p-4">
        <i18n path="onboarding.sync-connections.sync-google.step1-description" tag="p">
          <template v-slot:sign-in-cta>
            <strong>{{ $t('onboarding.sync-connections.sync-google.sign-in-cta') }}</strong>
          </template>
        </i18n>
      </b-card>

      <b-card :title="$t('onboarding.sync-connections.sync-google.step2-title')" img-top img-src="/static/images/illustrations/13.svg" class="p-4">
        <p>{{ $t('onboarding.sync-connections.sync-google.step2-description') }}</p>
      </b-card>

      <b-card :title="$t('onboarding.sync-connections.sync-google.step3-title')" img-top img-src="/static/images/illustrations/14.svg" class="p-4">
        <p>{{ $t('onboarding.sync-connections.sync-google.step3-description') }}</p>
      </b-card>

    </b-card-group>

    <div class="action-buttons">
      <b-btn class="m-0 mb-3" :href="signInWithGoogleURL" :disabled="!signInWithGoogleURL" variant="google">
        {{ $t('onboarding.sync-connections.sync-google.sign-in-cta') }}
      </b-btn>
    </div>

    <contacts-upload-modal ref="contactsUploadModal" network="GOOGLE" v-bind="{ rejectedCompanyNames, rejectedDomains }"
      @finished-uploading="a => this.$emit('finished-uploading', a)"/>

  </div>
</template>

<script>
import axios from 'axios';
import qs from 'querystring';
import ContactsUploadModal from '@/modals/contacts-upload';
import validationsMixin from '@/mixins/validations';
import { formatErr } from '@/lib/utils';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    redirectUri: {
      type: String,
      default: () => null,
    },
    rejectedCompanyNames: {
      type: Array,
      default: () => [],
    },
    rejectedDomains: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ContactsUploadModal,
  },
  mixins: [
    validationsMixin,
  ],
  mounted() {
    if (window.location.hash && window.location.hash.includes('access_token')) {
      this.onCallback(window.location.hash.substr(1));
      window.location.hash = '';
    }
  },
  computed: {
    ...mapRoot([ 'servicesOrigin' ]),
    signInWithGoogleURL() {
      if (this.redirectUri) {
        const scope = 'https://www.googleapis.com/auth/contacts.readonly';
        return `${this.servicesOrigin}/auth-redirects/google?scope=${scope}&return_uri=${this.redirectUri}`;
      } else {
        return null;
      }
    },
  },
  methods: {
    async onCallback(queryHash) {
      const { contactsUploadModal } = this.$refs;
      try {
        contactsUploadModal.setState('LOADING');

        const { access_token: accessToken } = qs.parse(queryHash);

        const { data } = await axios.get('https://people.googleapis.com/v1/people/me/connections', {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            personFields: 'names,emailAddresses',
            pageSize: 2000,
            sortOrder: 'LAST_MODIFIED_DESCENDING',
          },
          validateStatus: status => status === 200,
        });

        if (!data || !Array.isArray(data.connections) || !data.connections.length) {
          return contactsUploadModal.setError(formatErr(new Error('No people were found'), {
            code: 'NO_PEOPLE_FOUND',
          }));
        }

        contactsUploadModal.setData({
          fields: [ 'First Name', 'Last Name', 'Email Address' ],
          data: data.connections.reduce((results, { names, emailAddresses }) => {
            const { givenName, familyName } = (names || []).filter(({ metadata }) => metadata && metadata.primary === true).shift() || {};
            const { value: emailAddress } = (emailAddresses || []).filter(({ metadata }) => metadata && metadata.primary === true).shift() || {};

            if (givenName && familyName && emailAddress && this.isRealEmailAddress(emailAddress)) {
              results.push({
                'First Name': givenName,
                'Last Name': familyName,
                'Email Address': emailAddress,
              });
            }

            return results;
          }, []),
        });
      } catch (err) {
        contactsUploadModal.setError(err);
      }
    },
  },
};
</script>

<style lang="scss">
.contacts-upload-google {
  .btn.close-x {
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    color: #000;
    opacity: 0.5;
    text-shadow: 0 1px 0 #fff;
  }

  .card-group {
    .card {
      border: none;
    }

    .card-footer {
      background-color: transparent;
      border-top: none;
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn, input {
      cursor: pointer;
    }

    .btn {
      width: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts-upload/GoogleParser.vue